// Totais do dia a partir dos títulos dos compromissos com horário ("Felipe 8 jogos",
// "Neiva 34 jogos 65 mesas avulsas"). Eventos de dia inteiro são anotações do dia e não
// entram na soma, para não contar duas vezes o que já está nos compromissos.
const QUANTITY_PATTERN =
  /(?:^|[^\p{L}\p{N}])(\d{1,5})\s+(\p{L}{3,})(?=$|[^\p{L}])/gu;
const IGNORED_UNITS = new Set([
  'min',
  'minuto',
  'minutos',
  'hora',
  'horas',
  'dia',
  'dias',
  'reais',
  'anos',
]);

const singular = unit =>
  unit.endsWith('s') && unit.length > 3 ? unit.slice(0, -1) : unit;
const pluralLabel = label => (label.endsWith('s') ? label : `${label}s`);

export const quantitiesFromTitle = title => {
  const totals = {};
  const text = String(title || '');
  QUANTITY_PATTERN.lastIndex = 0;
  let match = QUANTITY_PATTERN.exec(text);
  while (match) {
    const unit = match[2].toLocaleLowerCase('pt-BR');
    if (!IGNORED_UNITS.has(unit)) {
      const key = singular(unit);
      totals[key] = totals[key] || { quantity: 0, label: unit };
      totals[key].quantity += Number(match[1]);
      if (Number(match[1]) > 1 && unit.endsWith('s')) totals[key].label = unit;
    }
    match = QUANTITY_PATTERN.exec(text);
  }
  return totals;
};

export const isDayNote = event => Boolean(event?.all_day);

// [{ quantity: 43, label: 'jogos' }, ...] ordenado pela maior quantidade.
export const dayQuantityTotals = events => {
  const totals = {};
  (events || [])
    .filter(event => !isDayNote(event) && event?.source !== 'contract')
    .forEach(event => {
      Object.entries(quantitiesFromTitle(event.title)).forEach(
        ([key, item]) => {
          totals[key] = totals[key] || { quantity: 0, label: item.label };
          totals[key].quantity += item.quantity;
          if (item.label.endsWith('s')) totals[key].label = item.label;
        }
      );
    });
  return Object.values(totals)
    .map(item => ({
      quantity: item.quantity,
      label:
        item.quantity === 1 ? singular(item.label) : pluralLabel(item.label),
    }))
    .sort((a, b) => b.quantity - a.quantity);
};

export const formatDayTotals = totals =>
  totals
    .map(item => `${item.quantity.toLocaleString('pt-BR')} ${item.label}`)
    .join(' · ');
